import Cookies from 'js-cookie'

/**
 * AgeVerification functionality.
 * @author Dayne Coulson-Hoffacker
 */
export default class AgeVerification {
  /**
   * Constructs a new AgeVerification instance.
   * @param {Object} options - Options.
   * @param {HTMLElement} options.element - Container.
   */
  constructor(options) {
    this.element = options.element
    this.omCheckButton = this.element.querySelector('[data-component="om_check"]')
    this.om_day = this.element.querySelector('#om_day')
    this.om_month = this.element.querySelector('#om_month')
    this.om_year = this.element.querySelector('#om_year')
    this.om_error = this.element.querySelector('#om_error')

    this.dayMonthValidation(this.om_day, this.om_month, 31)
    this.dayMonthValidation(this.om_month, this.om_year, 12)

    this.omCheckButton.addEventListener('click', e => {
      var day = parseInt(this.om_day.value),
        month = parseInt(this.om_month.value),
        year = parseInt(this.om_year.value)

      var age = this.calculate_age(year, month - 1, day)

      if (age < 18) {
        this.om_error.classList.add('not-allowed')
      } else {
        Cookies.set('allowed_entry_live', 'true')
        history.scrollRestoration = 'manual'
        window.scroll({
          top: 0,
          left: 0,
          behavior: 'auto'
        })
        this.om_error.classList.remove('not-allowed')
        if (document.body.classList.contains('home')) {
          document.body.classList.add('play-home-animation')
        }
        this.element.classList.add('hide')
        document.body.style.overflow = 'auto'
      }
    })

    const cookieExists = Cookies.get('allowed_entry_live')

    if (!cookieExists) {
      this.element.classList.add('show')
    }
  }

  calculate_age(year, month, day) {
    var birthday = +new Date(year, month, day)
    return ~~((Date.now() - birthday) / (31557600000))
  }

  dayMonthValidation(elem, nextElem, max) {
    elem.addEventListener('keyup', e => {
      var el = elem.value,
      elemString = new String(el),
      elemNumber = parseInt(el)

      // Days can't be greater than 31 and months can't be greater than 12
      if (elemNumber > max) {
        elem.value = 1
      }

      // Check is value is numeric and length is greater than 2, if so, then
      // let's focus the next element. This is meant for the day and month fields.
      if (!isNaN(elemString) && elemString.length > 1) {
        nextElem.focus()
      }
    })
  }

}



// WEBPACK FOOTER //
// ./components/age-verification/index.js